import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ProductAddStateType } from 'features/Product/@types/ProductAdd'
import { DISCOVERY_LABEL_TYPE_ID } from 'features/Product/constant/product'
import {
  fetchAttributeOptions,
  // fetchBomCategories,
  fetchBrands,
  fetchDiscoveryLabel,
  fetchGetBaseUom,
  fetchGetWimsConstants,
  fetchGetStorageHandling,
  fetchProductTypes,
  // fetchStatusSource,
  fetchGetAssetsMaster,
  setConstants,
  createProduct,
  SLICE_NAME_PRODUCT_ADD,
  uploadProductImage,
} from './thunk'

const initialState: ProductAddStateType = {
  isLoading: false,
  dependentValue: {
    primaryCategory: null,
  },
  constants: {
    productTypes: [],
    businessTaggings: [],
    businessUnits: [],
    companies: [],
    // statusSource: [],
    // bomCategories: [],
    brands: [],
    labelImages: [],
    labelPromotions: [],
    storageHandlings: [],
    shelfs: [],
    storageTypes: [],
    specialHandlingDetails: [],
    baseUoms: [],
    // pickingUoms: [],
    // receivingUoms: [],
    // vendorUoms: [],
    productPlacements: [],
    skuMovementHandlings: [],
    storageBinTypeHub: [],
    storageBinTypeWarehouse: [],
    storageOutboundTypeHub: [],
    imageHost: '',
    bomCategories: [],
    socialMediaList: [],
    ppnList: [],
    papLocationTypes: [],
    registrationStatus: [],
    sourceStatus: [],
    uomTypes: [],
  },
}

const slice = createSlice({
  name: SLICE_NAME_PRODUCT_ADD,
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setPrimaryCategory: (
      state,
      action: PayloadAction<ProductAddStateType['dependentValue']['primaryCategory']>,
    ) => {
      state.dependentValue.primaryCategory = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createProduct.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(createProduct.fulfilled, (state) => {
      state.isLoading = false
    })
    builder.addCase(createProduct.rejected, (state) => {
      state.isLoading = false
    })
    builder.addCase(uploadProductImage.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(uploadProductImage.fulfilled, (state) => {
      state.isLoading = false
    })
    builder.addCase(uploadProductImage.rejected, (state) => {
      state.isLoading = false
    })

    builder.addCase(fetchProductTypes.fulfilled, (state, action) => {
      state.constants.productTypes = action.payload
    })
    builder.addCase(fetchAttributeOptions.fulfilled, (state, action) => {
      if (action.meta.arg === 'BUSINESS_UNIT') {
        state.constants.businessUnits = action.payload
      } else if (action.meta.arg === 'BUSINESS_TAGGING') {
        state.constants.businessTaggings = action.payload
      } else if (action.meta.arg === 'COMPANY') {
        state.constants.companies = action.payload
      }
    })
    builder.addCase(fetchBrands.fulfilled, (state, action) => {
      state.constants.brands = action.payload
    })
    builder.addCase(fetchDiscoveryLabel.fulfilled, (state, action) => {
      if (action.meta.arg.typeId === DISCOVERY_LABEL_TYPE_ID.IMAGE) {
        state.constants.labelImages = action.payload
      } else if (action.meta.arg.typeId === DISCOVERY_LABEL_TYPE_ID.PROMOTION) {
        state.constants.labelPromotions = action.payload
      }
    })

    // --- Operational
    builder.addCase(fetchGetWimsConstants.fulfilled, (state, action) => {
      const {
        product_shelves,
        product_special_handling,
        // picking_uoms,
        product_placements,
        // receiving_uoms,
        // sku_movement_handlings,
        // storage_types,
        // vendor_uoms,
        product_storage_types,
        product_movement_handling,
        product_image_host,
        product_bill_of_material_criteria,
        social_media_list,
        product_ppn,
        pap_location_types,
        product_source_status,
        product_type_uom,
      } = action.payload

      state.constants.specialHandlingDetails = product_special_handling

      state.constants.shelfs = product_shelves
      state.constants.storageTypes = product_storage_types
      // state.constants.pickingUoms = picking_uoms
      // state.constants.receivingUoms = receiving_uoms
      // state.constants.vendorUoms = vendor_uoms
      state.constants.productPlacements = product_placements
      state.constants.skuMovementHandlings = product_movement_handling
      state.constants.imageHost = product_image_host
      state.constants.bomCategories = product_bill_of_material_criteria
      state.constants.socialMediaList = social_media_list
      state.constants.ppnList = product_ppn
      state.constants.papLocationTypes = pap_location_types
      state.constants.sourceStatus = product_source_status
      state.constants.uomTypes = product_type_uom
    })
    builder.addCase(fetchGetStorageHandling.fulfilled, (state, action) => {
      state.constants.storageHandlings = action.payload.filter(
        (item) => !item.name.toLowerCase().includes(`[invalid]`),
      )
    })
    builder.addCase(fetchGetBaseUom.fulfilled, (state, action) => {
      state.constants.baseUoms = action.payload
    })
    builder.addCase(fetchGetAssetsMaster.fulfilled, (state, action) => {
      const { key } = action.meta.arg || {}
      const data = action.payload

      if (key) {
        state.constants[key] = data
      } else {
        state.constants.storageBinTypeHub = data
        state.constants.storageBinTypeWarehouse = data
        state.constants.storageOutboundTypeHub = data
      }
    })
    builder.addCase(setConstants, (state, action) => {
      state.constants = {
        ...state.constants,
        ...action.payload,
      }
    })
  },
})

export const { setIsLoading, setPrimaryCategory } = slice.actions
export default slice.reducer
